import moment from 'moment'
export function date_format(value,options={}){ 
  let moment_instance = null, response  = ''
  if(options?.input?.unix) moment_instance = moment.unix(value)
  else moment_instance = moment.utc(value)
  if(options?.output?.formate) response = moment_instance.format(options.output.formate)
  else response = moment_instance.format('DD-MMM-YYYY hh:mm:ss A')
  if(response=='Invalid date') response=''
  return response
}